import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-circular-notice',
  templateUrl: './circular-notice.component.html',
  styleUrls: ['./circular-notice.component.scss']
})
export class CircularNoticeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
